// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"652":"e5211c06","823":"27c22428","849":"c0ee9104"}[chunkId] + ".css";
};